import { BarcodeOutlined,  DeleteOutlined,  ExclamationCircleFilled } from "@ant-design/icons";
import { Button, Col, Input, Row, Typography, message, Modal } from "antd";
import React, { useMemo, useState, useEffect, useCallback, useRef, ChangeEvent } from "react";
import MainTable from "./MainTable";
import StockModal from "./Modals/Stock/StockModal";
import ItemDetailsModal from "./Modals/ItemDetails/ItemDetailsModal";
import { useMutation } from "react-query";
import { getCurrentPriceByBarcode } from "../../api/pricesCurrent";
import { useDispatch, useSelector } from "react-redux";
import { mainActions } from "../../store/main/mainSlice";
import CustomersModal from "./Modals/Customers/CustomersModal";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import HoldOrderTwo from "./Modals/Hold/HoldOrderTwo";
import RestoreOrder from "./Modals/RestoreOrder/RestorOrders";
import { useReactToPrint } from "react-to-print";
import { SaleDetail } from "../../api/sales";
import { Search } from "../UI/Search/Search";
import { useTranslation } from "react-i18next";
import { ProceedPayment } from "./Modals/ProceedPayment/proceedpayment";
import HistoryModal from "./Modals/History/HistoryModal";
import { getCurrencyRates } from "../../api/currency";
import CheckAdmin from "./Modals/Discount/CheckAdmin";
import AddItemModal from "./Modals/AddItemModal/addItemModal";
import ItemNotFoundModal from "./Modals/ItemNotFoundModal/itemnotfoundmodal";
import InvoicePrintSimple from "./InvoicePrintSimple";
import { getReceiptCurrLS } from "../../utils/main-utils";

interface Item {
  barcode: number;
  name: string;
  author: string;
  year: string;
  inStock: string;
  qty: number;
  price: number;
  total: number;
  image: "./Images/bread.png";
}

export const PrintContext = React.createContext<any>(null);
export const ChangeStateContext = React.createContext<any>(null);
export const exchangeRateContext = React.createContext<any>(null);
export const tenderedLBPContext = React.createContext<any>(null);
export const returnedContext = React.createContext<any>(null);
export const TotalContext = React.createContext<any>(null);
export const checkItemQuantityFunctionContext = React.createContext<any>(null);
const MainFour = () => {
  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;
  const secondaryCurrencyString = localStorage.getItem("secondaryCurrency");
  const secondaryCurrency = secondaryCurrencyString
    ? JSON.parse(secondaryCurrencyString)
    : null;
  const taxRateString = localStorage.getItem("taxRate");
  const taxRate = taxRateString ? JSON.parse(taxRateString).taxRate : null;
  const [t] = useTranslation("common");
  const [isStockOpen, setIsStockOpen] = useState<boolean>(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState<boolean>(false);
  const [isCustomerOpen, setIsCustomerOpen] = useState<boolean>(false);
  const [isVoidOrderOpen, setIsVoidOrderOpen] = useState<boolean>(false);
  const [isHoldOrderOpen, setIsHoldOrderOpen] = useState<boolean>(false);
  const [isRestoreOrderOpen, setIsRestoreOrderOpen] = useState<boolean>(false);
  const [isAddItemOpen, setIsAddItemOpen] = useState<boolean>(false);
  const [isOpenProceed, setIsOpenProceed] = useState(false);
  const [selectedItem, setSelectedItem] = useState<Item | null>();
  const [barcode, setBarcode] = useState<string>("");
  const [isOpenHistory, setisOpenHistory] = useState(false);
  const [exchangeRate, setExchangeRate] = useState(0);
  const [openDiscount, setOpenDiscount] = useState(false);
  const [search, setSearch] = useState("");
  const [isOpenNotFound, setIsOpenNotFound] = useState(false);
  const [tenderedUSD, setTenderedUSD] = useState<string>("");
  const [dateString, setDateString] = useState<string>("");
  const [timeString, setTimeString] = useState<string>("");
  const [tenderedLBP, setTenderedLBP] = useState<string>("");
  const [returnedUSD, setReturnedUSD] = useState<string>("");
  const [returnedLBP, setReturnedLBP] = useState<string>("");
  const [isPayOpen, setIsPayOpen] = useState<boolean>(false);
  const [isDeliveryOpen, setIsDeliveryOpen] = useState<boolean>(false);
  const [overpaymentUSD, setOverpaymentUSD] = useState<string>("");
  const [deliveryCharge, setDeliveryCharge] = useState(null)

  const dispatch = useDispatch();

  const customer = useSelector((state: any) => state?.main?.customer);
  const items = useSelector((state: any) => state?.main?.items);

  // useEffect(() => {
  //   console.log('mainFour - ', items)
  // }, [items])

  const discount = useSelector((state: any) => state.main.discount);
  const totalPrice = useSelector((state: any) => state.main.totalPrice);
  const invoiceNo = useSelector((state: any) => state.main.invoiceNo);

  const ReduxDeliveryCharge = useSelector((state: any) => state.main.deliveryCharge)
  const ReduxDeliveryLocation = useSelector((state: any) => state.main.deliveryLocation)
  const ReduxDeliveryChargeText = useSelector((state: any) => state.main.deliveryChargeText)

  const ReduxInvoiceType = useSelector((state: any) => state.main.invoiceType)

  const [, contextHolder] = message.useMessage();

  const receiptCurr = getReceiptCurrLS()

  const getCardStyles = useMemo(() => {
    return (hasItems: boolean) => {
      if (hasItems) {
        return { backgroundColor: "#1677FF", cursor: "pointer" };
      } else {
        return { cursor: "not-allowed" };
      }
    };
  }, []);

  const error = () => {
    setIsOpenNotFound(true);
  };

  // let barcodeScan = "";

  // useEffect(() => {
  //   const handleKeyDown = (e: any) => {
  //     if (e.keyCode === 13 && barcodeScan.length > 3) {
  //       !isAddItemOpen && handleScan(barcodeScan);
  //       barcodeScan = "";
  //       return;
  //     }
  //     if (e.keyCode === 16) {
  //       return;
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //     barcodeScan += e.key;

  //     setTimeout(() => {
  //       barcodeScan = "";
  //     }, 200);
  //   };

  //   document.addEventListener("keydown", handleKeyDown);

  //   return function cleanup() {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // });

  // const handleScan = (barcodeString: string) => {
  //   window.alert(barcodeString)
  //   if (barcodeString && !isOpenProceed) {

  //     getItemByBarcodeMutation(barcodeString)
  //       .then((res) => {
  //         const item = res?.data;
  //         dispatch(
  //           mainActions.addItem({
  //             name: item?.item.name,
  //             itemId: item?.item.id,
  //             barcode: item?.item.barcode,
  //             cost: item?.averageCost,
  //             price: item?.averagePrice,
  //             totalPrice: item?.averagePrice,
  //             isTaxable: item?.item.isTaxable,
  //             extraCharge: 0,
  //             tax: item?.item?.tax,
  //             discount: null,
  //             notes: "Example sale item notes",
  //             qty: 1,
  //             qtyInStock: item?.currentQuantity,
  //             specifications: [],
  //           })
  //         );
  //       })
  //       .catch(() => {
  //         error();
  //       });
  //     setBarcode("");
  //   }
  // };

  const { mutateAsync: getExchangeRate } = useMutation(
    "getExchangeRates",
    () => getCurrencyRates(secondaryCurrency?.id),
    {
      onSuccess: (result) => {
        setExchangeRate(result?.data.cuRate[0].rate);
      },
    }
  );

  useEffect(() => {
    if (items.length <= 0) {
      dispatch(mainActions.removeCustomer());
    }
    if (items.length === 1) {
      getExchangeRate();
    }
  }, [getExchangeRate, items]);

  const { mutateAsync: getItemByBarcodeMutation, isLoading: isItemLoading } =
    useMutation(
      "getItemByBarcode",
      (barcode: string) => getCurrentPriceByBarcode(barcode),
      {
        onSuccess: (res) => { },
      }
    );

  useEffect(() => {
    secondaryCurrency?.id && getExchangeRate();
  }, [secondaryCurrency?.id]);

  const calculateExtras = useCallback((): number => {
    let total = 0;
    items.map((item: SaleDetail) =>
      item.specifications.map((spec) => (total += spec.extraCharge))
    );
    return total;
  }, [items]);

  const calculateTaxableAmount = useCallback((): number => {
    let total = 0;
    items
      .filter((item: SaleDetail) => item.isTaxable)
      .map((item: any) => {
        return (total += item.price * item.qty);
      });

    return total;
  }, [items]);

  const [finalPrice, setFinalPrice] = useState<any>();

  useEffect(() => {
    setFinalPrice(
      discount.type === "%"
        ? (
          (totalPrice +
            calculateExtras() +
            calculateTaxableAmount() * taxRate) *
          ((100 - discount.amount) / 100) +
          ReduxDeliveryCharge
        ).toFixed(2)
        : (
          totalPrice +
          calculateExtras() +
          calculateTaxableAmount() * taxRate -
          discount.amount + ReduxDeliveryCharge
        ).toFixed(2)
    );
  }, [
    totalPrice,
    taxRate,
    discount.amount,
    calculateExtras,
    calculateTaxableAmount,
    discount.type,
  ]);
  useEffect(() => {
    dispatch(mainActions.setFinalPrice(Number(finalPrice) + Number(deliveryCharge)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalPrice, deliveryCharge]);

  const componentRef = useRef<any>();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      setTenderedUSD("");
      setTenderedLBP("");
      setReturnedUSD("");
      setReturnedLBP("");
      setOverpaymentUSD("");
      setIsPayOpen(false);
      dispatch(mainActions.clearInvoice());
    },
  });

  useEffect(() => {
    const date = new Date();

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    setDateString(
      `${day.toString().padStart(2, "0")}/${month
        .toString()
        .padStart(2, "0")}/${year}`
    );

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    setTimeString(
      `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
    );
  }, [handlePrint, isOpenProceed]);

  function numberWithCommas(x: number) {
    return x && x?.toFixed(2)?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  function numberWithCommasLBP(x: number) {
    return x && x.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

//   function numberWithCommasLBP(x: number) {
//     const banknotes = [100000, 50000, 20000, 10000, 5000]; // Available banknotes in descending order
//     let remaining = x;
//     let sum = 0;

//     for (let i = 0; i < banknotes.length; i++) {
//         const count = Math.floor(remaining / banknotes[i]); // Calculate how many times the current banknote can be used
//         sum += count * banknotes[i]; // Add the value of the banknote * number of times used to the sum
//         remaining -= count * banknotes[i]; // Update the remaining amount
//     }

//     // If remaining is closer to the next lower banknote, add that banknote
//     if (remaining > banknotes[banknotes.length - 1] / 2) {
//         sum += banknotes[banknotes.length - 1];
//     }

//     return sum && sum.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
// }

  function number(x: number) {
    return x && x.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }

  const addItem = (item: any) => {
    dispatch(
      mainActions.addItem({
        name: item?.item.name,
        itemId: item?.item.id,
        barcode: item?.item.barcode,
        cost: item?.averageCost,
        price: item?.lastPrice,
        totalPrice: item?.lastPrice,
        isTaxable: item?.item.isTaxable,
        extraCharge: 0,
        tax: item?.tax,
        discount: null,
        notes: null,
        qty: 1,
        qtyInStock: item?.currentQuantity,
        specifications: [],
      })
    );
  };
  useEffect(() => {
    setTenderedUSD((Number(deliveryCharge) + Number(finalPrice)).toString());
  }, [finalPrice, deliveryCharge]);

  useEffect(() => {
    if (discount.type === "#" && discount.amount > Number(totalPrice)) {
      dispatch(
        mainActions.addDiscount({
          amount: 0,
          type: "#",
        })
      );
    }
  }, [discount.amount, discount.type, items, totalPrice]);

  // useEffect(() => {
  //   console.log('totalPrice - ', totalPrice)
  // }, [totalPrice])

  const confirm = () => {
    Modal.confirm({
      width: "500px",
      title: (
        <>
          <Row>
            <Col span={3}>
              <ExclamationCircleFilled
                style={{
                  marginTop: "22px",
                  fontSize: "45px",
                  marginRight: "12px",
                  color: "#FFBC39",
                }}
              />
            </Col>

            <Col span={19}>
              <Col
                style={{
                  fontSize: "32px",
                  color: "#212121",
                }}
              >
                {" "}
                {t("remove-customer")}
              </Col>
              <Col
                span={24}
                style={{
                  fontSize: "16px",
                  color: "#212121",
                  wordWrap: "break-word",
                }}
              >
                {t("please-confirm-deleting-this-customer")}
              </Col>
            </Col>
          </Row>
        </>
      ),

      icon: null,
      centered: true,
      onOk: () => {
        customer?.name && dispatch(mainActions.removeCustomer());
        document.body.classList.remove("body-scroll-lock");
      },
      onCancel: () => {
        document.body.classList.remove("body-scroll-lock");
      },
      okText: `${t("confirm")}`,
      cancelText: `${t("cancel")}`,
      okButtonProps: {
        style: {
          height: "40px",
          background: "#1677FF",
          color: "#fff",
          width: "100px",
        },
      },
      cancelButtonProps: {
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          height: "40px",
          width: "100px",
        },
      },
    });
  };

  const [isQuantityInStock, setIsQuantityInStock] = useState(false)
  return (
    <PrintContext.Provider value={handlePrint}>
      <ChangeStateContext.Provider value={{ tenderedUSD, setTenderedUSD }}>
        <exchangeRateContext.Provider value={{ exchangeRate, setExchangeRate }}>
          <tenderedLBPContext.Provider value={{ tenderedLBP, setTenderedLBP }}>
            <returnedContext.Provider
              value={{
                returnedLBP,
                returnedUSD,
                setReturnedUSD,
                setReturnedLBP,
                overpaymentUSD,
                setOverpaymentUSD,
              }}
            >
              <TotalContext.Provider value={{ totalPrice }}>
                {contextHolder}
                <Row>
                  <Col span={18}>
                    <Row gutter={[10, 10]}>
                      <Col offset={1} span={9}>
                        <Input
                          style={{ height: "40px" }}
                          type="number"
                          className="btn-shadow"
                          placeholder={`${t("barcode")}`}
                          value={barcode}
                          onPressEnter={() => {
                            barcode &&
                              getItemByBarcodeMutation(barcode)
                                .then((res) => {
                                  const item = res?.data;
                                  addItem(item);
                                })
                                .catch(() => {
                                  error();
                                });

                            setBarcode("");
                          }}
                          onChange={(e) => {
                            setBarcode(e.target.value.toString());
                          }}
                          suffix={
                            <BarcodeOutlined
                              style={{ fontSize: "20px", color: "#8C8C8C" }}
                              onClick={() => {
                                barcode &&
                                  getItemByBarcodeMutation(barcode)
                                    .then((res) => {
                                      const item = res?.data;
                                      addItem(item);
                                    })
                                    .catch(() => {
                                      error();
                                    });

                                setBarcode("");
                              }}
                            />
                          }
                        />
                      </Col>
                      <Col span={9}>
                        <Search
                          value={search}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </Col>
                      <Col offset={4}>
                        <Button
                          className="Button"
                          type="text"
                          onClick={() => {
                            items.length > 0 && setIsVoidOrderOpen(true);
                          }}
                          icon={
                            <DeleteOutlined
                              style={{
                                color: items.length > 0 ? "#F5222D" : "#bdbdbd",
                                cursor:
                                  items.length > 0 ? "pointer" : "default",
                                fontSize: "25px",
                                paddingTop: "12px",
                              }}
                            />
                          }
                          size="small"
                        />
                      </Col>
                      <Col span={23} offset={1}>
                        <MainTable
                          search={search}
                          isItemLoading={isItemLoading}
                          setSelectedItem={setSelectedItem}
                          setIsDetailsOpen={setIsDetailsOpen}
                          setIsQuantityInStock={setIsQuantityInStock}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col offset={1} span={5}>
                    {customer?.name &&
                      <Row>
                        <Col
                          span={24}
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: "16px",
                              marginLeft: "5px",
                            }}
                          >
                            <b>{t('customer')}: </b>
                            {customer?.name}{" "}
                            {customer?.code && `(${customer.code})`}
                          </Typography>
                        </Col>
                      </Row>
                    }
                    {ReduxInvoiceType.id && <Row>
                      <Col
                        span={24}
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <Typography
                          style={{
                            fontSize: "16px",
                            marginLeft: "5px",
                          }}
                        >
                          <b>{t('restore-order')}: {ReduxInvoiceType.typeName.toLowerCase()} </b>
                        </Typography>
                      </Col>
                    </Row>}
                    <Row
                      style={{
                        backgroundColor: "#EEF5FF",
                        minHeight: "80vh",
                        borderRadius: "10px",
                        marginTop: "20px",
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Row
                        style={{
                          backgroundColor: "white",
                          padding: "20px 10px",
                        }}
                        gutter={[0, 10]}
                      >
                        <Col
                          span={10}
                          offset={1}
                          className="CardTwo"
                          onClick={() => {
                            setIsAddItemOpen(true);
                          }}
                          style={getCardStyles(true)}
                        >
                          {t("add-quantity-F10")}
                        </Col>

                        <Col
                          span={10}
                          offset={1}
                          className="CardTwo"
                          style={getCardStyles(items.length > 0 && ReduxInvoiceType.id === null)}
                          onClick={() => {
                            items.length > 0 && ReduxInvoiceType.id === null && setIsHoldOrderOpen(true);
                          }}
                        >
                          {t("hold-order")}
                        </Col>

                        <Col
                          span={10}
                          offset={1}
                          className="CardTwo"
                          style={getCardStyles(items.length <= 0)}
                          onClick={() => {
                            items.length <= 0 && setIsRestoreOrderOpen(true);
                          }}
                        >
                          {t("restore-order")}
                        </Col>

                        <Col
                          span={10}
                          offset={1}
                          className="CardTwo"
                          style={getCardStyles(true)}
                          onClick={() => {
                            setIsStockOpen(true);
                          }}
                        >
                          {t("show-items-F4")}
                        </Col>

                        <Col
                          span={10}
                          offset={1}
                          className="CardTwo"
                          style={getCardStyles(items.length > 0)}
                          onClick={() => {
                            items.length > 0 && setIsCustomerOpen(true);
                          }}
                        >
                          {t("choose-customer-F9")}
                        </Col>
                        <Col
                          span={10}
                          offset={1}
                          style={getCardStyles(customer?.name)}
                          className="CardTwo"
                          onClick={() => {
                            customer?.id && confirm();
                          }}
                        >
                          {t("remove-customer")}
                        </Col>

                        <Col
                          span={10}
                          offset={1}
                          className="CardTwo"
                          style={getCardStyles(true)}
                          onClick={() => {
                            setisOpenHistory(true);
                          }}
                        >
                          {t("show-history")}
                        </Col>

                        <Col
                          span={10}
                          offset={1}
                          className="CardTwo"
                          style={getCardStyles(items.length > 0)}
                          onClick={() => {
                            items.length > 0 && setOpenDiscount(true);
                          }}
                        >
                          {t("add-discount")}
                          {/* s */}
                        </Col>
                      </Row>
                      {/* ------------------------------------------------------------------- */}
                      <Row
                        style={{
                          backgroundColor: "white",
                          padding: "20px 10px",
                        }}
                      >
                        <Col span={24} className="checkout-row">
                          <Typography className="checkout-txt">
                            {t("subtotal")}:
                          </Typography>
                          <Typography className="checkout-txt">
                            {receiptCurr === 'usd' ? numberWithCommas(Number(totalPrice) + calculateExtras()) : numberWithCommasLBP((Number(totalPrice) + calculateExtras()) * exchangeRate)}{" "}
                            {receiptCurr === 'usd' ? mainCurrency?.abbreviation : secondaryCurrency?.abbreviation}
                          </Typography>
                        </Col>
                        <Col span={24} className="checkout-row">
                          <Typography className="checkout-txt">
                            {t("tax")}:
                          </Typography>
                          <Typography className="checkout-txt">
                            {receiptCurr === 'usd' ? numberWithCommas(calculateTaxableAmount() * Number(taxRate)) : numberWithCommasLBP((calculateTaxableAmount() * Number(taxRate)) * exchangeRate)}{" "}
                            {receiptCurr === 'usd' ? mainCurrency?.abbreviation : secondaryCurrency?.abbreviation}
                          </Typography>
                        </Col>
                        <Col span={24} className="checkout-row">
                          <Typography className="checkout-txt">
                            {t("discount")}:
                          </Typography>
                          <Typography className="checkout-txt">
                            {discount?.amount || 0
                              ? discount?.type === "%"
                                ? discount?.amount
                                : `${receiptCurr === 'usd' ? discount.amount.toFixed(2) : numberWithCommasLBP(discount.amount.toFixed(2) * exchangeRate)}`
                              : 0}

                            {discount?.type === "%"
                              ? "%"
                              : ` ${receiptCurr === 'usd' ? mainCurrency?.abbreviation : secondaryCurrency?.abbreviation}`}
                          </Typography>
                        </Col>

                        <Col span={24} className="checkout-row">
                          <Typography className="checkout-txt">
                            {t("delivery")}:
                          </Typography>
                          <Typography className="checkout-txt">
                            {receiptCurr === 'usd' ? numberWithCommas(ReduxDeliveryCharge ?? 0) : numberWithCommasLBP(ReduxDeliveryCharge * exchangeRate ?? 0)} {" "}
                            {receiptCurr === 'usd' ? mainCurrency?.abbreviation : secondaryCurrency?.abbreviation}
                          </Typography>
                        </Col>

                        <Col span={24} className="checkout-row">
                          <Typography className="checkout-txt-primary">
                            {t("total")}:
                          </Typography>

                          <Typography className="checkout-txt-primary">
                            {!isNaN(Number(finalPrice)) &&
                              numberWithCommas(Number(finalPrice))}{" "}
                            {mainCurrency?.abbreviation}
                          </Typography>
                        </Col>

                        <Col offset={1} span={23} className="checkout-row">
                          <Typography className="checkout-txt">
                            {t("exchange-rate")}
                          </Typography>
                          <Typography className="checkout-txt">
                            {number(exchangeRate)}
                          </Typography>
                        </Col>
                        <Col offset={1} span={23} className="checkout-row">
                          <Typography className="checkout-txt">
                            {t("total-in-lbp")}
                          </Typography>
                          <Typography className="checkout-txt">
                            {number(exchangeRate * finalPrice)} {"LBP "}
                          </Typography>
                        </Col>
                        <Col span={24} style={{ marginTop: "30px" }}>
                          <Button
                            style={
                              items.length > 0 && !isQuantityInStock
                                ? {
                                  height: "50px",
                                  fontSize: "20px",
                                  backgroundColor: "#1677FF",
                                  color: "#fff",
                                  cursor: "pointer",
                                }
                                : {
                                  height: "50px",
                                  fontSize: "20px",
                                  backgroundColor: "#bdbdbd",
                                  color: "#fff",
                                  cursor: "not-allowed",
                                }
                            }
                            block
                            onClick={() => {
                              items.length > 0 && !isQuantityInStock && setIsOpenProceed(true);
                              //items.length > 0 && handlePrint();
                            }}
                          >
                            {t("place-order-enter")}
                          </Button>
                          <div style={{ display: "none" }}>
                            {/* <PrinterComponent componentRef={componentRef}/> */}
                            <InvoicePrintSimple
                              dateString={dateString}
                              timeString={timeString}
                              componentRef={componentRef}
                              exchangeRate={exchangeRate}
                              secondaryCurrency={secondaryCurrency}
                              mainCurrency={mainCurrency}
                              deliveryCharge={deliveryCharge}
                              totalTax={calculateTaxableAmount() * taxRate}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* ------------------------------------------------------------------- */}
                    </Row>
                  </Col>
                </Row>
                {/* -----------Modals---------- */}
                {selectedItem && (
                  <ItemDetailsModal
                    isOpen={isDetailsOpen}
                    setIsOpen={setIsDetailsOpen}
                    item={selectedItem}
                  />
                )}
                <StockModal isOpen={isStockOpen} setIsOpen={setIsStockOpen} />
                <CustomersModal
                  isCustomerOpen={isCustomerOpen}
                  setIsCustomerOpen={setIsCustomerOpen}
                />
                <DeleteModal
                  open={isVoidOrderOpen}
                  setOpen={setIsVoidOrderOpen}
                  onOk={() => {
                    dispatch(mainActions.clearInvoice());
                    dispatch(
                      mainActions.setInvoiceType({
                        id: null,
                        typeName: null,
                        isActive: null
                      })
                    )
                    dispatch(
                      mainActions.addDelivery({
                        deliveryCharge: null,
                        deliveryLocation: {
                          id: null,
                          location: null
                        },
                        deliveryChargeText: null
                      })
                    )
                  }}
                  name={""}
                />
                <HoldOrderTwo
                  open={isHoldOrderOpen}
                  setOpen={setIsHoldOrderOpen}
                />
                <RestoreOrder
                  setIsRestoreOpen={setIsRestoreOrderOpen}
                  isRestoreOpen={isRestoreOrderOpen}
                />
                <ProceedPayment
                  isOpenProceed={isOpenProceed}
                  setIsOpenProceed={setIsOpenProceed}
                  isPayOpen={isPayOpen}
                  setIsPayOpen={setIsPayOpen}
                  setDeliveryCharge={setDeliveryCharge}
                  deliveryCharge={deliveryCharge}
                />
                <HistoryModal
                  isOpenHistory={isOpenHistory}
                  setisOpenHistory={setisOpenHistory}
                />
                <AddItemModal
                  open={isAddItemOpen}
                  setOpen={setIsAddItemOpen}
                  getItemByBarcodeMutation={getItemByBarcodeMutation}
                />

                <CheckAdmin open={openDiscount} setOpen={setOpenDiscount} />

                <ItemNotFoundModal
                  isOpenNotFound={isOpenNotFound}
                  setIsOpenNotFound={setIsOpenNotFound}
                />
                {/* </checkItemQuantityFunctionContext.Provider> */}
              </TotalContext.Provider>
            </returnedContext.Provider>
          </tenderedLBPContext.Provider>
        </exchangeRateContext.Provider>
      </ChangeStateContext.Provider>
    </PrintContext.Provider>
  );
};

export default MainFour;
